import { render, staticRenderFns } from "./queue-log-table.vue?vue&type=template&id=c91a08be&scoped=true&"
import script from "./queue-log-table.vue?vue&type=script&lang=js&"
export * from "./queue-log-table.vue?vue&type=script&lang=js&"
import style0 from "./queue-log-table.vue?vue&type=style&index=0&id=c91a08be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91a08be",
  null
  
)

export default component.exports